import { createAction, props } from "@ngrx/store"

export const generatePublicKey = createAction(
    '[Developer page Module] generate public key',
    props<{publicKeyDto}>()
)

export const generatePublicKeyFailed = createAction(
    '[Developer page Module] STATUS: generate public key failed'
)

export const generatePublicKeySuccess = createAction(
    '[Developer page Module] STATUS: generate public key success'
)